import React, { useState, useCallback } from 'react';
import { JmapClient } from './lib/jmap.js';
import { CryptoClient } from './lib/crypto.js';
import { Login } from './pages/Login.jsx';
import { Mailbox } from './pages/Mailbox.jsx';

// Root: holds the session (JMAP + crypto clients) and swaps between the login
// screen and the mailbox once authenticated. Deliberately dependency-light —
// a small hand-rolled state machine, no router needed for the MVP shell.
export function App() {
  const [session, setSession] = useState(null); // { jmap, crypto, email, identity }
  const [error, setError] = useState(null);

  const handleLogin = useCallback(async ({ email, password }) => {
    setError(null);
    try {
      const jmap = new JmapClient({
        baseUrl: '',
        authHeader: JmapClient.basicAuth(email, password),
      });
      await jmap.connect();
      const crypto = new CryptoClient();
      // The user's PQC identity (private keys) would be unlocked here from the
      // browser keystore in the hardened design; for now we look up the public
      // side from the directory so send/verify works.
      setSession({ jmap, crypto, email });
    } catch (e) {
      setError(e.message || 'login failed');
    }
  }, []);

  const handleLogout = useCallback(() => setSession(null), []);

  if (!session) {
    return <Login onLogin={handleLogin} error={error} />;
  }
  return <Mailbox session={session} onLogout={handleLogout} />;
}
